// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cq","homeContent__bottom":"c-i_cr","homeContent__cardHolder":"c-i_cs","homeContent__seoTextHolder":"c-i_ct"};